import * as React from 'react';

/**
 * A React helper hook for scheduling a layout effect with a fallback to a regular effect for environments
 * where layout effects should not be used (such as server-side rendering).
 *
 * Returns React's useLayoutEffect or useEffect, depending if the document object is available or not respectively.
 **/ const useIsomorphicLayoutEffect = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;

export { useIsomorphicLayoutEffect };
